import styles from './NoData.module.css';

function NoData({message, height="100%"}) {

    return (
        <div className={styles.container} style={{height: height}}>
            <strong>{message}</strong>
        </div>
    )
}

export default NoData;
